module.exports = __webpack_public_path__ + "static/img-f3d084141e4b55ee8b700dafa9ea6af1.jpg";